import { render, staticRenderFns } from "./PasswordlessLogin.vue?vue&type=template&id=7f4bde5d&"
import script from "./PasswordlessLogin.vue?vue&type=script&lang=js&"
export * from "./PasswordlessLogin.vue?vue&type=script&lang=js&"
import style0 from "./PasswordlessLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports